import React, { useState } from 'react';
import './styles.css';

function App() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleMenuToggle = () => setIsMenuOpen(!isMenuOpen);

/*    const handleRegistrationSubmit = (e) => {
        e.preventDefault();
        alert('Obrigado pela sua inscrição! Entraremos em contacto em breve.');
        e.target.reset();
    };*/

    const handleContactSubmit = (e) => {
        e.preventDefault();
        alert('Mensagem enviada com sucesso! Responderemos o mais breve possível.');
        e.target.reset();
    };

    return (
        <>
            {/* Ink blots and child drawings */}
            <div className="ink-blot ink-blot-1"></div>
            <div className="ink-blot ink-blot-2"></div>
            <div className="child-drawing drawing-sun"></div>
            <div className="child-drawing drawing-tree"></div>
            <div className="child-drawing drawing-bird"></div>

            {/* HEADER */}
            <header className="sticky top-0 z-50 bg-beige shadow-md hand-drawn-border">
                <div className="container mx-auto px-4 py-3 flex flex-col md:flex-row items-center justify-between">
                    <div className="flex items-center mb-4 md:mb-0">
                        <div className="relative">
                            <img src="URL_LOGO" alt="Logo Tribo Terra" className="h-12 w-12 rounded-full object-cover mr-3 border-2 border-yellow" />
                            <div className="absolute -bottom-2 -right-2 bg-yellow w-6 h-6 rounded-full flex items-center justify-center">
                                <i className="fas fa-leaf text-xs text-beige"></i>
                            </div>
                        </div>
                        <h1 className="text-2xl font-bold text-moss font-caveat">Aldeia dos Melritos</h1>
                    </div>
                    <nav className="hidden md:flex space-x-8">
                        <a href="#home" className="nav-link active text-brown font-medium">Início</a>
                        <a href="#about" className="nav-link text-brown font-medium">Sobre Nós</a>
                        <a href="#programs" className="nav-link text-brown font-medium">Programas</a>
                        <a href="#gallery" className="nav-link text-brown font-medium">Galeria</a>
                        <a href="#blog" className="nav-link text-brown font-medium">Blog</a>
                        <a href="#contact" className="nav-link text-brown font-medium">Contactos</a>
                    </nav>
                    <div className="md:hidden">
                        <button onClick={handleMenuToggle} className="text-brown focus:outline-none">
                            <i className="fas fa-bars text-2xl"></i>
                        </button>
                    </div>
                </div>
                <div className={`${isMenuOpen ? '' : 'hidden'} md:hidden bg-beige py-4 px-4 shadow-lg hand-drawn-border`}>
                    <div className="flex flex-col space-y-3">
                        <a href="#home" className="nav-link active text-brown font-medium">Início</a>
                        <a href="#about" className="nav-link text-brown font-medium">Sobre Nós</a>
                        <a href="#programs" className="nav-link text-brown font-medium">Programas</a>
                        <a href="#gallery" className="nav-link text-brown font-medium">Galeria</a>
                        <a href="#blog" className="nav-link text-brown font-medium">Blog</a>
                        <a href="#contact" className="nav-link text-brown font-medium">Contactos</a>
                    </div>
                </div>
            </header>

            {/* HERO */}
            <section id="home" className="hero min-h-screen flex items-center justify-center text-beige">
                <div className="container mx-auto px-4 text-center relative z-10">
                    <div className="hand-drawn-border inline-block px-6 py-2 bg-beige bg-opacity-20 mb-6">
                        <p className="text-yellow font-bold">Aprendizagem ao Ar Livre</p>
                    </div>
                    <h1 className="text-4xl md:text-6xl font-bold mb-6 font-kalam">Conectando Crianças à Natureza</h1>
                    <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">Programas educativos ao ar livre que inspiram amor pelo planeta e desenvolvimento pessoal.</p>
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <a href="#programs" className="btn-primary text-beige px-8 py-3 rounded-full font-bold relative overflow-hidden">
                            <span className="relative z-10">Nossos Programas</span>
                        </a>
                        <a href="#contact" className="bg-beige text-moss px-8 py-3 rounded-full font-bold border-2 border-beige hover:bg-transparent hover:text-beige transition hand-drawn-border">
                            Contacte-nos
                        </a>
                    </div>
                </div>
            </section>

            {/* ABOUT */}
            <section id="about" className="py-20 bg-beige relative overflow-hidden">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16 relative">
                        <h2 className="text-3xl md:text-4xl font-bold mb-4 font-kalam inline-block">Sobre Nós</h2>
                        <div className="w-24 h-1 bg-yellow mx-auto mb-6"></div>
                        <p className="max-w-3xl mx-auto text-lg">A Tribo Terra nasceu da paixão por criar experiências transformadoras na natureza para crianças e jovens.</p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="p-6 bg-white rounded-lg shadow hand-drawn-border text-center">
                            <i className="fas fa-tree text-4xl text-moss mb-4"></i>
                            <h3 className="font-bold text-xl mb-2">Conexão com a Natureza</h3>
                            <p>Explorar, brincar e aprender no ambiente natural, desenvolvendo respeito e amor pelo planeta.</p>
                        </div>
                        <div className="p-6 bg-white rounded-lg shadow hand-drawn-border text-center">
                            <i className="fas fa-users text-4xl text-moss mb-4"></i>
                            <h3 className="font-bold text-xl mb-2">Aprendizagem em Comunidade</h3>
                            <p>Fomentamos colaboração, empatia e responsabilidade coletiva nas nossas atividades.</p>
                        </div>
                        <div className="p-6 bg-white rounded-lg shadow hand-drawn-border text-center">
                            <i className="fas fa-lightbulb text-4xl text-moss mb-4"></i>
                            <h3 className="font-bold text-xl mb-2">Criatividade e Curiosidade</h3>
                            <p>Incentivamos o pensamento crítico, a experimentação e a autonomia através do brincar livre.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* PROGRAMS */}
            <section id="programs" className="py-20 bg-lightgreen relative overflow-hidden">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16 relative">
                        <h2 className="text-3xl md:text-4xl font-bold mb-4 font-kalam inline-block">Programas</h2>
                        <div className="w-24 h-1 bg-yellow mx-auto mb-6"></div>
                        <p className="max-w-3xl mx-auto text-lg">Descubra os diferentes programas que oferecemos para crianças de várias idades.</p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="p-6 bg-white rounded-lg shadow hand-drawn-border text-center">
                            <h3 className="font-bold text-xl mb-2">Mini Exploradores</h3>
                            <p>Para crianças dos 3 aos 5 anos, primeiras aventuras na floresta com muita brincadeira e descoberta.</p>
                        </div>
                        <div className="p-6 bg-white rounded-lg shadow hand-drawn-border text-center">
                            <h3 className="font-bold text-xl mb-2">Tribo Jovem</h3>
                            <p>Dos 6 aos 12 anos, atividades de exploração, construção, jogos e desafios em grupo.</p>
                        </div>
                        <div className="p-6 bg-white rounded-lg shadow hand-drawn-border text-center">
                            <h3 className="font-bold text-xl mb-2">Aventuras em Família</h3>
                            <p>Encontros mensais para famílias viverem momentos únicos na natureza, fortalecendo vínculos.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* GALLERY */}
            <section id="gallery" className="py-20 bg-beige relative overflow-hidden">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16 relative">
                        <h2 className="text-3xl md:text-4xl font-bold mb-4 font-kalam inline-block">Galeria</h2>
                        <div className="w-24 h-1 bg-yellow mx-auto mb-6"></div>
                        <p className="max-w-3xl mx-auto text-lg">Veja alguns momentos capturados nas nossas atividades.</p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <img src="URL_FOTO1" alt="Atividade 1" className="rounded-lg shadow hand-drawn-border" />
                        <img src="URL_FOTO2" alt="Atividade 2" className="rounded-lg shadow hand-drawn-border" />
                        <img src="URL_FOTO3" alt="Atividade 3" className="rounded-lg shadow hand-drawn-border" />
                    </div>
                </div>
            </section>

            {/* BLOG */}
            <section id="blog" className="py-20 bg-lightgreen relative overflow-hidden">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16 relative">
                        <h2 className="text-3xl md:text-4xl font-bold mb-4 font-kalam inline-block">Blog</h2>
                        <div className="w-24 h-1 bg-yellow mx-auto mb-6"></div>
                        <p className="max-w-3xl mx-auto text-lg">Fique a par das últimas novidades, dicas e reflexões.</p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="p-6 bg-white rounded-lg shadow hand-drawn-border">
                            <h3 className="font-bold text-xl mb-2">A importância do brincar livre</h3>
                            <p>Descubra porque o brincar livre na natureza é fundamental para o desenvolvimento infantil.</p>
                        </div>
                        <div className="p-6 bg-white rounded-lg shadow hand-drawn-border">
                            <h3 className="font-bold text-xl mb-2">Como preparar-se para a floresta</h3>
                            <p>Dicas práticas para garantir conforto e segurança nas atividades ao ar livre.</p>
                        </div>
                        <div className="p-6 bg-white rounded-lg shadow hand-drawn-border">
                            <h3 className="font-bold text-xl mb-2">Educação na Natureza: um novo olhar</h3>
                            <p>Entenda como esta abordagem pedagógica promove autonomia, criatividade e resiliência.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CONTACT */}
            <section id="contact" className="py-20 bg-beige relative overflow-hidden">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16 relative">
                        <h2 className="text-3xl md:text-4xl font-bold mb-4 font-kalam inline-block">Contactos</h2>
                        <div className="w-24 h-1 bg-yellow mx-auto mb-6"></div>
                        <p className="max-w-3xl mx-auto text-lg">Entre em contacto connosco para mais informações ou agendar uma visita.</p>
                    </div>
                    <form onSubmit={handleContactSubmit} className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow hand-drawn-border space-y-4">
                        <div>
                            <label htmlFor="name" className="block font-medium mb-1">Nome</label>
                            <input type="text" id="name" name="name" required className="w-full px-4 py-2 border rounded focus:outline-none" />
                        </div>
                        <div>
                            <label htmlFor="email" className="block font-medium mb-1">Email</label>
                            <input type="email" id="email" name="email" required className="w-full px-4 py-2 border rounded focus:outline-none" />
                        </div>
                        <div>
                            <label htmlFor="message" className="block font-medium mb-1">Mensagem</label>
                            <textarea id="message" name="message" rows="4" required className="w-full px-4 py-2 border rounded focus:outline-none"></textarea>
                        </div>
                        <button type="submit" className="btn-primary text-beige px-8 py-3 rounded-full font-bold relative overflow-hidden">
                            Enviar Mensagem
                        </button>
                    </form>
                </div>
            </section>

            {/* FOOTER */}
            <footer className="bg-moss text-beige py-8 text-center">
                <p>&copy; {new Date().getFullYear()} Tribo Terra. Todos os direitos reservados.</p>
            </footer>
        </>
    );
}

export default App;
